import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderHistoryItem', {
  oneArticle: '{{quantity}} Artículo',
  manyArticles: '{{quantity}} Artículos',
  separator: '•',
  repeatOrder: 'Repetir pedido'
});
